// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"z1-z","colorTextValue":"A1-z","swatches":"B1-z","collapseLink":"C1-z","isCollapsed":"D1-z","dropdown":"E1-z","disabled":"F1-z"};